import * as types from 'models/actionTypes'

export const requestRatings = (jobId) => ({
    type: types.REQUEST_RATINGS,
    jobId,
})

export const receiveRating = (jobId, rating) => ({
    type: types.RECEIVE_RATING,
    jobId,
    rating,
})

export const receiveRatings = (jobId, ratings) => ({
    type: types.RECEIVE_RATINGS,
    jobId,
    ratings,
})

export const requestRatingOptions = () => ({
    type: types.REQUEST_RATING_OPTIONS,
})

export const receiveRatingOptions = (options) => ({
    type: types.RECEIVE_RATING_OPTIONS,
    options,
})

export const submitRating = (jobId, tagId, id, kind, value, note) => ({
    type: types.SUBMIT_RATING,
    jobId,
    tagId,
    id,
    kind,
    value,
    note,
})
